<template>
    <div id="app">
        <v-app id="inspire">
            <v-card>
                <v-card-text>
                    <p align="center" style="margin-top: 0; margin-bottom: 0"><b>
                            <font face="Verdana" color="#008000">FORMULARIOS EI 085: LISTADOS DE CHEQUEO Y REGISTRO DE
                                AUDITORÍA</font>
                        </b></p>
                    <p style="margin-top: 0; margin-bottom: 0">&nbsp;</p>
                    <p style="margin-top: 0; margin-bottom: 0"><i>
                            <font face="Tahoma" size="2">NOTA: Estos listados de chequeo son orientativos.
                                Se pueden ampliar / modificar a criterio de los auditores internos.</font>
                        </i></p>
                    <p style="margin-top: 0; margin-bottom: 0">&nbsp;</p>
                    <b>
                        <font color="#008000" face="Verdana">PROCEDIMIENTOS</font>
                    </b>

                    <table border="1" width="100%">
                        <tr>
                            <td width="25%">
                                <p align="center"><b>
                                        <font face="Verdana" size="1">ARCHIVO EN .DOC</font>
                                    </b></p>
                            </td>
                            <td width="25%">
                                <p align="center"><b>
                                        <font face="Verdana" size="1">ARCHIVO EN .PDF</font>
                                    </b></p>
                            </td>
                            <td>
                                <p align="center"><b>
                                        <font face="Verdana" size="1">DESCRIPCIÓN</font>
                                    </b></p>
                            </td>
                        </tr>
                        <tr>
                            <td width="25%" align="center">
                                <span style="font-family: Verdana; font-size: 10px; cursor: pointer; color: blue;"
                                    @click="verDoc('MP4.01.01')">MP4.01.01</span>
                            </td>
                            <td width="25%" align="center">
                                <span style="font-family: Verdana; font-size: 10px; cursor: pointer; color: blue;"
                                    @click="verPdf('MP4.01.01')">MP4.01.01</span>
                            </td>
                            <td>
                                <font face="Verdana" size="1">Diseño, aprobación e implementación de los requisitos
                                    generales
                                    del
                                    SGI</font>
                            </td>
                        </tr>
                        <tr>
                            <td width="25%" align="center">
                                <span style="font-family: Verdana; font-size: 10px; cursor: pointer; color: blue;"
                                    @click="verDoc('MP4.01.01')">
                                    MP4.02.01
                                </span>
                            </td>
                            <td width="25%" align="center">
                                <span style="font-family: Verdana; font-size: 10px; cursor: pointer; color: blue;"
                                    @click="verPdf('MP4.01.01')">
                                    MP4.02.01
                                </span>
                            </td>
                            <td>
                                <font face="Verdana" size="1">Elaboración, aprobación, distribución y control de los
                                    documentos
                                    del SGI</font>
                            </td>
                        </tr>
                        <tr>
                            <td width="25%" align="center">
                                <span style="font-family: Verdana; font-size: 10px; cursor: pointer; color: blue;"
                                    @click="verDoc('MP5.01.01')">MP5.01.01</span>
                            </td>
                            <td width="25%" align="center">
                                <span style="font-family: Verdana; font-size: 10px; cursor: pointer; color: blue;"
                                    @click="verPdf('MP5.01.01')">MP5.01.01</span>
                            </td>
                            <td>
                                <font face="Verdana" size="1">Responsabilidad de la Dirección</font>
                            </td>
                        </tr>
                        <tr>
                            <td width="25%" align="center">
                                <span style="font-family: Verdana; font-size: 10px; cursor: pointer; color: blue;"
                                    @click="verDoc('MP5.01.02')">MP5.01.02</span>
                            </td>
                            <td width="25%" align="center">
                                <span style="font-family: Verdana; font-size: 10px; cursor: pointer; color: blue;"
                                    @click="verPdf('MP5.01.02')">MP5.01.02</span>
                            </td>
                            <td>
                                <font face="Verdana" size="1">Objetivos y metas</font>
                            </td>
                        </tr>
                        <tr>
                            <td width="25%" align="center">
                                <span style="font-family: Verdana; font-size: 10px; cursor: pointer; color: blue;"
                                    @click="verDoc('MP5.02.01-MP5.02.02')">MP5.02.01 /
                                    MP5.02.02</span>
                            </td>
                            <td width="25%" align="center">
                                <span style="font-family: Verdana; font-size: 10px; cursor: pointer; color: blue;"
                                    @click="verPdf('MP5.02.01-MP5.02.02')">MP5.02.01 /
                                    MP5.02.02</span>
                            </td>
                            <td>
                                <font face="Verdana" size="1">Requisitos legales y de otro tipo&nbsp;/ Revisión de la
                                    situación
                                    inicial</font>
                            </td>
                        </tr>
                        <tr>
                            <td width="25%" align="center">
                                <span style="font-family: Verdana; font-size: 10px; cursor: pointer; color: blue;"
                                    @click="verDoc('MP5.03.01-MP5.03.02')">MP5.03.01 /
                                    MP5.03.02</span>
                            </td>
                            <td width="25%" align="center">
                                <span style="font-family: Verdana; font-size: 10px; cursor: pointer; color: blue;"
                                    @click="verPdf('MP5.03.01-MP5.03.02')">MP5.03.01 /
                                    MP5.03.02</span>
                            </td>
                            <td>
                                <font face="Verdana" size="1">Evaluación de riesgos&nbsp;/ Trabajos con riesgos
                                    especiales
                                </font>
                            </td>
                        </tr>

                        <tr>
                            <td width="25%" align="center">
                                <span style="font-family: Verdana; font-size: 10px; cursor: pointer; color: blue;"
                                    @click="verDoc('MP5.03.03')">MP5.03.03</span>
                            </td>
                            <td width="25%" align="center">
                                <span style="font-family: Verdana; font-size: 10px; cursor: pointer; color: blue;"
                                    @click="verPdf('MP5.03.03')">MP5.03.03</span>
                            </td>
                            <td>
                                <font face="Verdana" size="1">Ciclo de vida</font>
                            </td>
                        </tr>

                        <tr>
                            <td width="25%" align="center">
                                <span style="font-family: Verdana; font-size: 10px; cursor: pointer; color: blue;"
                                    @click="verDoc('MP5.03.04')">MP5.03.04</span>
                            </td>
                            <td width="25%" align="center">
                                <span style="font-family: Verdana; font-size: 10px; cursor: pointer; color: blue;"
                                    @click="verPdf('MP5.03.04')">MP5.03.04</span>
                            </td>
                            <td>
                                <font face="Verdana" size="1">Evaluación del impacto ambiental</font>
                            </td>
                        </tr>
                        <tr>
                            <td width="25%" align="center">
                                <span style="font-family: Verdana; font-size: 10px; cursor: pointer; color: blue;"
                                    @click="verDoc('MP5.04.01')">MP5.04.01</span>
                            </td>
                            <td width="25%" align="center">
                                <span style="font-family: Verdana; font-size: 10px; cursor: pointer; color: blue;"
                                    @click="verPdf('MP5.04.01')">MP5.04.01</span>
                            </td>
                            <td>
                                <font face="Verdana" size="1">Planificación del sistema de gestión de la calidad, medio
                                    ambiente
                                    y
                                    SST</font>
                            </td>
                        </tr>

                        <tr>
                            <td width="25%" align="center">
                                <span style="font-family: Verdana; font-size: 10px; cursor: pointer; color: blue;"
                                    @click="verDoc('MP5.04.02')">MP5.04.02</span>
                            </td>
                            <td width="25%" align="center">
                                <span style="font-family: Verdana; font-size: 10px; cursor: pointer; color: blue;"
                                    @click="verPdf('MP5.04.02')">MP5.04.02</span>
                            </td>
                            <td>
                                <font face="Verdana" size="1">Preparación y respuesta ante emergencias</font>
                            </td>
                        </tr>

                        <tr>
                            <td width="25%" align="center">
                                <span style="font-family: Verdana; font-size: 10px; cursor: pointer; color: blue;"
                                    @click="verDoc('MP5.04.03')">MP5.04.03</span>
                            </td>
                            <td width="25%" align="center">
                                <span style="font-family: Verdana; font-size: 10px; cursor: pointer; color: blue;"
                                    @click="verPdf('MP5.04.03')">MP5.04.03</span>
                            </td>
                            <td>
                                <font face="Verdana" size="1">Programa SOL</font>
                            </td>
                        </tr>

                        <tr>
                            <td width="25%" align="center">
                                <span style="font-family: Verdana; font-size: 10px; cursor: pointer; color: blue;"
                                    @click="verDoc('MP5.05.01')">MP5.05.01</span>
                            </td>
                            <td width="25%" align="center">
                                <span style="font-family: Verdana; font-size: 10px; cursor: pointer; color: blue;"
                                    @click="verPdf('MP5.05.01')">MP5.05.01</span>
                            </td>
                            <td>
                                <font face="Verdana" size="1">Responsabilidad, autoridad, comunicación</font>
                            </td>
                        </tr>

                        <tr>
                            <td width="25%" align="center">
                                <span style="font-family: Verdana; font-size: 10px; cursor: pointer; color: blue;"
                                    @click="verDoc('MP5.06.01')">MP5.06.01</span>
                            </td>
                            <td width="25%" align="center">
                                <span style="font-family: Verdana; font-size: 10px; cursor: pointer; color: blue;"
                                    @click="verPdf('MP5.06.01')">MP5.06.01</span>
                            </td>
                            <td>
                                <font face="Verdana" size="1">Revisión por la Dirección</font>
                            </td>
                        </tr>

                        <tr>
                            <td width="25%" align="center">
                                <span style="font-family: Verdana; font-size: 10px; cursor: pointer; color: blue;"
                                    @click="verDoc('MP6.02.01')">MP6.02.01</span>
                            </td>
                            <td width="25%" align="center">
                                <span style="font-family: Verdana; font-size: 10px; cursor: pointer; color: blue;"
                                    @click="verPdf('MP6.02.01')">MP6.02.01</span>
                            </td>
                            <td>
                                <font face="Verdana" size="1">Gestión de recursos humanos</font>
                            </td>
                        </tr>
                        <tr>
                            <td width="25%" align="center">
                                <span style="font-family: Verdana; font-size: 10px; cursor: pointer; color: blue;"
                                    @click="verDoc('MP6.03.01')">MP6.03.01</span>
                            </td>
                            <td width="25%" align="center">
                                <span style="font-family: Verdana; font-size: 10px; cursor: pointer; color: blue;"
                                    @click="verPdf('MP6.03.01')">MP6.03.01</span>
                            </td>
                            <td>
                                <font face="Verdana" size="1">Infraestructura. Ambiente de trabajo. Condiciones
                                    sanitarias y
                                    ambientales</font>
                            </td>
                        </tr>
                        <tr>
                            <td width="25%" align="center">
                                <span style="font-family: Verdana; font-size: 10px; cursor: pointer; color: blue;"
                                    @click="verDoc('MP6.03.02')">MP6.03.02</span>
                            </td>
                            <td width="25%" align="center">
                                <span style="font-family: Verdana; font-size: 10px; cursor: pointer; color: blue;"
                                    @click="verPdf('MP6.03.02')">MP6.03.02</span>
                            </td>
                            <td>
                                <font face="Verdana" size="1">Máquinas, herramientas y equipos</font>
                            </td>
                        </tr>

                        <tr>
                            <td width="25%" align="center">
                                <span style="font-family: Verdana; font-size: 10px; cursor: pointer; color: blue;"
                                    @click="verDoc('MP6.03.03')">MP6.03.03</span>
                            </td>
                            <td width="25%" align="center">
                                <span style="font-family: Verdana; font-size: 10px; cursor: pointer; color: blue;"
                                    @click="verPdf('MP6.03.03')">MP6.03.03</span>
                            </td>
                            <td>
                                <font face="Verdana" size="1">Protección contra incendios</font>
                            </td>
                        </tr>

                        <tr>
                            <td width="25%" align="center">
                                <span style="font-family: Verdana; font-size: 10px; cursor: pointer; color: blue;"
                                    @click="verDoc('MP6.03.05')">MP6.03.05</span>
                            </td>
                            <td width="25%" align="center">
                                <span style="font-family: Verdana; font-size: 10px; cursor: pointer; color: blue;"
                                    @click="verPdf('MP6.03.05')">MP6.03.05</span>
                            </td>
                            <td>
                                <font face="Verdana" size="1">Mantenimiento de equipos de producción, obras y edilicios
                                </font>
                            </td>
                        </tr>

                        <tr>
                            <td width="25%" align="center">
                                <span style="font-family: Verdana; font-size: 10px; cursor: pointer; color: blue;"
                                    @click="verDoc('MP7.01.01')">MP7.01.01</span>
                            </td>
                            <td width="25%" align="center">
                                <span style="font-family: Verdana; font-size: 10px; cursor: pointer; color: blue;"
                                    @click="verPdf('MP7.01.01')">MP7.01.01</span>
                            </td>
                            <td>
                                <font face="Verdana" size="1">Planificación de la realización del producto</font>
                            </td>
                        </tr>
                        <tr>
                            <td width="25%" align="center">
                                <span style="font-family: Verdana; font-size: 10px; cursor: pointer; color: blue;"
                                    @click="verDoc('MP7.01.02')">MP7.01.02</span>
                            </td>
                            <td width="25%" align="center">
                                <span style="font-family: Verdana; font-size: 10px; cursor: pointer; color: blue;"
                                    @click="verPdf('MP7.01.02')">MP7.01.02</span>
                            </td>
                            <td>
                                <font face="Verdana" size="1">Organización, ejecución y verificación del servicio
                                    posventa&nbsp;
                                </font>
                            </td>
                        </tr>
                        <tr>
                            <td width="25%" align="center">
                                <span style="font-family: Verdana; font-size: 10px; cursor: pointer; color: blue;"
                                    @click="verDoc('MP7.01.03')">MP7.01.03</span>
                            </td>
                            <td width="25%" align="center">
                                <span style="font-family: Verdana; font-size: 10px; cursor: pointer; color: blue;"
                                    @click="verPdf('MP7.01.03')">MP7.01.03</span>
                            </td>
                            <td>
                                <font face="Verdana" size="1">Planes y programas de gestión ambiental y SST</font>
                            </td>
                        </tr>
                        <tr>
                            <td width="25%" align="center">
                                <span style="font-family: Verdana; font-size: 10px; cursor: pointer; color: blue;"
                                    @click="verDoc('MP7.02.01')">MP7.02.01</span>
                            </td>
                            <td width="25%" align="center">
                                <span style="font-family: Verdana; font-size: 10px; cursor: pointer; color: blue;"
                                    @click="verPdf('MP7.02.01')">MP7.02.01</span>
                            </td>
                            <td>
                                <font face="Verdana" size="1">Procesos relacionados con el cliente</font>
                            </td>
                        </tr>
                        <tr>
                            <td width="25%" align="center">
                                <span style="font-family: Verdana; font-size: 10px; cursor: pointer; color: blue;"
                                    @click="verDoc('MP7.03.01')">MP7.03.01</span>
                            </td>
                            <td width="25%" align="center">
                                <span style="font-family: Verdana; font-size: 10px; cursor: pointer; color: blue;"
                                    @click="verPdf('MP7.03.01')">MP7.03.01</span>
                            </td>
                            <td>
                                <font face="Verdana" size="1">Diseño y desarrollo</font>
                            </td>
                        </tr>
                        <tr>
                            <td width="25%" align="center">
                                <span style="font-family: Verdana; font-size: 10px; cursor: pointer; color: blue;"
                                    @click="verDoc('MP7.04.01')">MP7.04.01</span>
                            </td>
                            <td width="25%" align="center">
                                <span style="font-family: Verdana; font-size: 10px; cursor: pointer; color: blue;"
                                    @click="verPdf('MP7.04.01')">MP7.04.01</span>
                            </td>
                            <td>
                                <font face="Verdana" size="1">Gestión de compras</font>
                            </td>
                        </tr>
                        <tr>
                            <td width="25%" align="center">
                                <span style="font-family: Verdana; font-size: 10px; cursor: pointer; color: blue;"
                                    @click="verDoc('MP7.04.02')">MP7.04.02</span>
                            </td>
                            <td width="25%" align="center">
                                <span style="font-family: Verdana; font-size: 10px; cursor: pointer; color: blue;"
                                    @click="verPdf('MP7.04.02')">MP7.04.02</span>
                            </td>
                            <td>
                                <font face="Verdana" size="1">Evaluación de subcontratistas y proveedores</font>
                            </td>
                        </tr>
                        <tr>
                            <td width="25%" align="center">
                                <span style="font-family: Verdana; font-size: 10px; cursor: pointer; color: blue;"
                                    @click="verDoc('MP7.04.03')">MP7.04.03</span>
                            </td>
                            <td width="25%" align="center">
                                <span style="font-family: Verdana; font-size: 10px; cursor: pointer; color: blue;"
                                    @click="verPdf('MP7.04.03')">MP7.04.03</span>
                            </td>
                            <td>
                                <font face="Verdana" size="1">Norma interna para subcontratistas</font>
                            </td>
                        </tr>
                        <tr>
                            <td width="25%" align="center">
                                <span style="font-family: Verdana; font-size: 10px; cursor: pointer; color: blue;"
                                    @click="verDoc('MP7.04.04-MP7.05.04')">MP7.04.04 /
                                    MP7.05.04</span>
                            </td>
                            <td width="25%" align="center">
                                <span style="font-family: Verdana; font-size: 10px; cursor: pointer; color: blue;"
                                    @click="verPdf('MP7.04.04-MP7.05.04')">MP7.04.04 /
                                    MP7.05.04</span>
                            </td>
                            <td>
                                <font face="Verdana" size="1">Verificación de los productos comprados&nbsp;/ Protección
                                    de los
                                    bienes
                                    del cliente</font>
                            </td>
                        </tr>
                        <tr>
                            <td width="25%" align="center">
                                <span style="font-family: Verdana; font-size: 10px; cursor: pointer; color: blue;"
                                    @click="verDoc('MP7.05.03')">MP7.05.03</span>
                            </td>
                            <td width="25%" align="center">
                                <span style="font-family: Verdana; font-size: 10px; cursor: pointer; color: blue;"
                                    @click="verPdf('MP7.05.03')">MP7.05.03</span>
                            </td>
                            <td>
                                <font face="Verdana" size="1">Identificación y trazabilidad de productos</font>
                            </td>
                        </tr>
                        <tr>
                            <td width="25%" align="center">
                                <span style="font-family: Verdana; font-size: 10px; cursor: pointer; color: blue;"
                                    @click="verDoc('MP7.05.05')">MP7.05.05</span>
                            </td>
                            <td width="25%" align="center">
                                <span style="font-family: Verdana; font-size: 10px; cursor: pointer; color: blue;"
                                    @click="verPdf('MP7.05.05')">MP7.05.05</span>
                            </td>
                            <td>
                                <font face="Verdana" size="1">Control de la preservación del producto</font>
                            </td>
                        </tr>
                        <tr>
                            <td width="25%" align="center">
                                <span style="font-family: Verdana; font-size: 10px; cursor: pointer; color: blue;"
                                    @click="verDoc('MP7.05.06')">MP7.05.06</span>
                            </td>
                            <td width="25%" align="center">
                                <span style="font-family: Verdana; font-size: 10px; cursor: pointer; color: blue;"
                                    @click="verPdf('MP7.05.06')">MP7.05.06</span>
                            </td>
                            <td>
                                <font face="Verdana" size="1">Control de entrega</font>
                            </td>
                        </tr>
                        <tr>
                            <td width="25%" align="center">
                                <span style="font-family: Verdana; font-size: 10px; cursor: pointer; color: blue;"
                                    @click="verDoc('MP7.05.07A')">MP7.05.07 -
                                    A</span>
                            </td>
                            <td width="25%" align="center">
                                <span style="font-family: Verdana; font-size: 10px; cursor: pointer; color: blue;"
                                    @click="verPdf('MP7.05.07A')">MP7.05.07 -
                                    A</span>
                            </td>
                            <td>
                                <font face="Verdana" size="1">Tratamiento de residuos</font>
                            </td>
                        </tr>
                        <tr>
                            <td width="25%" align="center">
                                <span style="font-family: Verdana; font-size: 10px; cursor: pointer; color: blue;"
                                    @click="verDoc('MP7.05.07B')">MP7.05.07 -
                                    B</span>
                            </td>
                            <td width="25%" align="center">
                                <span style="font-family: Verdana; font-size: 10px; cursor: pointer; color: blue;"
                                    @click="verPdf('MP7.05.07B')">MP7.05.07 -
                                    B</span>
                            </td>
                            <td>
                                <font face="Verdana" size="1">Tratamiento de residuos - Detallado</font>
                            </td>
                        </tr>
                        <tr>
                            <td width="25%" align="center">
                                <span style="font-family: Verdana; font-size: 10px; cursor: pointer; color: blue;"
                                    @click="verDoc('MP7.06.01')">MP7.06.01</span>
                            </td>
                            <td width="25%" align="center">
                                <span style="font-family: Verdana; font-size: 10px; cursor: pointer; color: blue;"
                                    @click="verPdf('MP7.06.01')">MP7.06.01</span>
                            </td>
                            <td>
                                <font face="Verdana" size="1">Control y calibración de los equipos de control y medición
                                </font>
                            </td>
                        </tr>
                        <tr>
                            <td width="25%" align="center">
                                <span style="font-family: Verdana; font-size: 10px; cursor: pointer; color: blue;"
                                    @click="verDoc('MP8.02.01')">MP8.02.01</span>
                            </td>
                            <td width="25%" align="center">
                                <span style="font-family: Verdana; font-size: 10px; cursor: pointer; color: blue;"
                                    @click="verPdf('MP8.02.01')">MP8.02.01</span>
                            </td>
                            <td>
                                <font face="Verdana" size="1">Medición de la satisfacción del cliente</font>
                            </td>
                        </tr>
                        <tr>
                            <td width="25%" align="center">
                                <span style="font-family: Verdana; font-size: 10px; cursor: pointer; color: blue;"
                                    @click="verDoc('MP8.02.03-MP8.04.02')">MP8.02.03 /
                                    MP8.04.02</span>
                            </td>
                            <td width="25%" align="center">
                                <span style="font-family: Verdana; font-size: 10px; cursor: pointer; color: blue;"
                                    @click="verPdf('MP8.02.03-MP8.04.02')">MP8.02.03 /
                                    MP8.04.02</span>
                            </td>
                            <td>
                                <font face="Verdana" size="1">Medición y seguimiento de los procesos de calidad, medio
                                    ambiente
                                    y
                                    SST. Control operativo&nbsp;/ Análisis de datos</font>
                            </td>
                        </tr>
                        <tr>
                            <td width="25%" align="center">
                                <span style="font-family: Verdana; font-size: 10px; cursor: pointer; color: blue;"
                                    @click="verDoc('MP8.02.04')">MP8.02.04</span>
                            </td>
                            <td width="25%" align="center">
                                <span style="font-family: Verdana; font-size: 10px; cursor: pointer; color: blue;"
                                    @click="verPdf('MP8.02.04')">MP8.02.04</span>
                            </td>
                            <td>
                                <font face="Verdana" size="1">Medición y seguimiento del producto</font>
                            </td>
                        </tr>
                        <tr>
                            <td width="25%" align="center">
                                <span style="font-family: Verdana; font-size: 10px; cursor: pointer; color: blue;"
                                    @click="verDoc('MP8.03.01-MP8.05.02')">MP8.03.01
                                    /MP8.05.02</span>
                            </td>
                            <td width="25%" align="center">
                                <span style="font-family: Verdana; font-size: 10px; cursor: pointer; color: blue;"
                                    @click="verPdf('MP8.03.01-MP8.05.02')">MP8.03.01
                                    /MP8.05.02</span>
                            </td>
                            <td>
                                <font face="Verdana" size="1">Gestión de no conformidades / Acciones preventivas y
                                    correctivas
                                </font>
                            </td>
                        </tr>

                        <tr>
                            <td width="25%" align="center">
                                <span style="font-family: Verdana; font-size: 10px; cursor: pointer; color: blue;"
                                    @click="verDoc('MP8.04.01')">MP8.04.01</span>
                            </td>
                            <td width="25%" align="center">
                                <span style="font-family: Verdana; font-size: 10px; cursor: pointer; color: blue;"
                                    @click="verPdf('MP8.04.01')">MP8.04.01</span>
                            </td>
                            <td>
                                <font face="Verdana" size="1">Control de Gestión</font>
                            </td>
                        </tr>
                        <tr>
                            <td width="25%" align="center">
                                <span style="font-family: Verdana; font-size: 10px; cursor: pointer; color: blue;"
                                    @click="verDoc('MP8.05.01')">MP8.05.01</span>
                            </td>
                            <td width="25%" align="center">
                                <span style="font-family: Verdana; font-size: 10px; cursor: pointer; color: blue;"
                                    @click="verPdf('MP8.05.01')">MP8.05.01</span>
                            </td>
                            <td>
                                <font face="Verdana" size="1">Gestión de mejoras. Sugerencias de mejoras</font>
                            </td>
                        </tr>
                    </table>
                    <p style="margin-top: 0; margin-bottom: 0">&nbsp;</p>
                    <b>
                        <font color="#008000" face="Verdana">INSTRUCCIONES</font>
                    </b>

                    <table border="1" width="100%">
                        <tr>
                            <td width="25%">
                                <p align="center"><b>
                                        <font face="Verdana" size="1">ARCHIVO EN .DOC</font>
                                    </b></p>
                            </td>
                            <td width="25%">
                                <p align="center"><b>
                                        <font face="Verdana" size="1">ARCHIVO EN .PDF</font>
                                    </b></p>
                            </td>
                            <td>
                                <p align="center"><b>
                                        <font face="Verdana" size="1">DESCRIPCIÓN</font>
                                    </b></p>
                            </td>
                        </tr>
                        <tr>
                            <td width="25%" align="center">
                                <span style="font-family: Verdana; font-size: 10px; cursor: pointer; color: blue;"
                                    @click="verDoc('MI5.04.02.01')">MI5.04.02.01</span>
                            </td>
                            <td width="25%" align="center">
                                <span style="font-family: Verdana; font-size: 10px; cursor: pointer; color: blue;"
                                    @click="verPdf('MI5.04.02.01')">MI5.04.02.01</span>
                            </td>
                            <td>
                                <font face="Verdana" size="1">Formación de brigadas contra incendios</font>
                            </td>
                        </tr>
                        <tr>
                            <td width="25%" align="center">
                                <span style="font-family: Verdana; font-size: 10px; cursor: pointer; color: blue;"
                                    @click="verDoc('MI5.04.02.02')">
                                    MI5.04.02.02
                                </span>
                            </td>
                            <td width="25%" align="center">
                                <span style="font-family: Verdana; font-size: 10px; cursor: pointer; color: blue;"
                                    @click="verPdf('MI5.04.02.02')">
                                    MI5.04.02.02
                                </span>
                            </td>
                            <td>
                                <font face="Verdana" size="1">Plan de emergencias</font>
                            </td>
                        </tr>
                        <tr>
                            <td width="25%" align="center">
                                <span style="font-family: Verdana; font-size: 10px; cursor: pointer; color: blue;"
                                    @click="verDoc('MI5.04.02.03')">MI5.04.02.03</span>
                            </td>
                            <td width="25%" align="center">
                                <span style="font-family: Verdana; font-size: 10px; cursor: pointer; color: blue;"
                                    @click="verPdf('MI5.04.02.03')">MI5.04.02.03</span>
                            </td>
                            <td>
                                <font face="Verdana" size="1">Atención de accidentes de trabajo</font>
                            </td>
                        </tr>
                        <tr>
                            <td width="25%" align="center">
                                <span style="font-family: Verdana; font-size: 10px; cursor: pointer; color: blue;"
                                    @click="verDoc('MP5.04.02.04')">MP5.04.02.04</span>
                            </td>
                            <td width="25%" align="center">
                                <span style="font-family: Verdana; font-size: 10px; cursor: pointer; color: blue;"
                                    @click="verPdf('MP5.04.02.04')">MP5.04.02.04</span>
                            </td>
                            <td>
                                <font face="Verdana" size="1">Primeros auxilios</font>
                            </td>
                        </tr>
                        <tr>
                            <td width="25%" align="center">
                                <span style="font-family: Verdana; font-size: 10px; cursor: pointer; color: blue;"
                                    @click="verDoc('MI6.02.01.02')">MI6.02.01.02</span>
                            </td>
                            <td width="25%" align="center">
                                <span style="font-family: Verdana; font-size: 10px; cursor: pointer; color: blue;"
                                    @click="verPdf('MI6.02.01.02')">MI6.02.01.02</span>
                            </td>
                            <td>
                                <font face="Verdana" size="1">Reglamento interno</font>
                            </td>
                        </tr>
                        <tr>
                            <td width="25%" align="center">
                                <span style="font-family: Verdana; font-size: 10px; cursor: pointer; color: blue;"
                                    @click="verDoc('MI6.03.01.03')">MI6.03.01.03</span>
                            </td>
                            <td width="25%" align="center">
                                <span style="font-family: Verdana; font-size: 10px; cursor: pointer; color: blue;"
                                    @click="verPdf('MI6.03.01.03')">MI6.03.01.03</span>
                            </td>
                            <td>
                                <font face="Verdana" size="1">Limpieza de tanques y cisternas
                                </font>
                            </td>
                        </tr>

                        <tr>
                            <td width="25%" align="center">
                                <span style="font-family: Verdana; font-size: 10px; cursor: pointer; color: blue;"
                                    @click="verDoc('MI6.03.01.04')">MI6.03.01.04</span>
                            </td>
                            <td width="25%" align="center">
                                <span style="font-family: Verdana; font-size: 10px; cursor: pointer; color: blue;"
                                    @click="verPdf('MI6.03.01.04')">MI6.03.01.04</span>
                            </td>
                            <td>
                                <font face="Verdana" size="1">Señalizaciones</font>
                            </td>
                        </tr>

                        <tr>
                            <td width="25%" align="center">
                                <span style="font-family: Verdana; font-size: 10px; cursor: pointer; color: blue;"
                                    @click="verDoc('MI6.03.01.05')">MI6.03.01.05</span>
                            </td>
                            <td width="25%" align="center">
                                <span style="font-family: Verdana; font-size: 10px; cursor: pointer; color: blue;"
                                    @click="verPdf('MI6.03.01.05')">MI6.03.01.05</span>
                            </td>
                            <td>
                                <font face="Verdana" size="1">Control de plagas</font>
                            </td>
                        </tr>
                        <tr>
                            <td width="25%" align="center">
                                <span style="font-family: Verdana; font-size: 10px; cursor: pointer; color: blue;"
                                    @click="verDoc('MI6.03.01.06')">MI6.03.01.06</span>
                            </td>
                            <td width="25%" align="center">
                                <span style="font-family: Verdana; font-size: 10px; cursor: pointer; color: blue;"
                                    @click="verPdf('MI6.03.01.06')">MI6.03.01.06</span>
                            </td>
                            <td>
                                <font face="Verdana" size="1">Condiciones sanitarias y ambientales</font>
                            </td>
                        </tr>

                        <tr>
                            <td width="25%" align="center">
                                <span style="font-family: Verdana; font-size: 10px; cursor: pointer; color: blue;"
                                    @click="verDoc('MI6.03.01.07')">MI6.03.01.07</span>
                            </td>
                            <td width="25%" align="center">
                                <span style="font-family: Verdana; font-size: 10px; cursor: pointer; color: blue;"
                                    @click="verPdf('MI6.03.01.07')">MI6.03.01.07</span>
                            </td>
                            <td>
                                <font face="Verdana" size="1">Infrasonidos, ruidos, ultrasonidos y vibraciones</font>
                            </td>
                        </tr>

                        <tr>
                            <td width="25%" align="center">
                                <span style="font-family: Verdana; font-size: 10px; cursor: pointer; color: blue;"
                                    @click="verDoc('MI6.03.02.01')">MI6.03.02.01</span>
                            </td>
                            <td width="25%" align="center">
                                <span style="font-family: Verdana; font-size: 10px; cursor: pointer; color: blue;"
                                    @click="verPdf('MI6.03.02.01')">MI6.03.02.01</span>
                            </td>
                            <td>
                                <font face="Verdana" size="1">Manejo y mantenimiento de equipos para izaje de cargas
                                </font>
                            </td>
                        </tr>

                        <tr>
                            <td width="25%" align="center">
                                <span style="font-family: Verdana; font-size: 10px; cursor: pointer; color: blue;"
                                    @click="verDoc('MI6.03.02.02')">MI6.03.02.02</span>
                            </td>
                            <td width="25%" align="center">
                                <span style="font-family: Verdana; font-size: 10px; cursor: pointer; color: blue;"
                                    @click="verPdf('MI6.03.02.02')">MI6.03.02.02</span>
                            </td>
                            <td>
                                <font face="Verdana" size="1">Manejo de autogrúas</font>
                            </td>
                        </tr>

                        <tr>
                            <td width="25%" align="center">
                                <span style="font-family: Verdana; font-size: 10px; cursor: pointer; color: blue;"
                                    @click="verDoc('MI6.03.02.03')">MI6.03.02.03</span>
                            </td>
                            <td width="25%" align="center">
                                <span style="font-family: Verdana; font-size: 10px; cursor: pointer; color: blue;"
                                    @click="verPdf('MI6.03.02.03')">MI6.03.02.03</span>
                            </td>
                            <td>
                                <font face="Verdana" size="1">Manejo de autoelevadores</font>
                            </td>
                        </tr>

                        <tr>
                            <td width="25%" align="center">
                                <span style="font-family: Verdana; font-size: 10px; cursor: pointer; color: blue;"
                                    @click="verDoc('MI6.03.02.04')">MI6.03.02.04</span>
                            </td>
                            <td width="25%" align="center">
                                <span style="font-family: Verdana; font-size: 10px; cursor: pointer; color: blue;"
                                    @click="verPdf('MI6.03.02.04')">MI6.03.02.04</span>
                            </td>
                            <td>
                                <font face="Verdana" size="1">Norma interna para tránsito vehicular</font>
                            </td>
                        </tr>
                        <tr>
                            <td width="25%" align="center">
                                <span style="font-family: Verdana; font-size: 10px; cursor: pointer; color: blue;"
                                    @click="verDoc('MI6.03.02.05')">MI6.03.02.05</span>
                            </td>
                            <td width="25%" align="center">
                                <span style="font-family: Verdana; font-size: 10px; cursor: pointer; color: blue;"
                                    @click="verPdf('MI6.03.02.05')">MI6.03.02.05</span>
                            </td>
                            <td>
                                <font face="Verdana" size="1">Aparatos con presión interna</font>
                            </td>
                        </tr>
                        <tr>
                            <td width="25%" align="center">
                                <span style="font-family: Verdana; font-size: 10px; cursor: pointer; color: blue;"
                                    @click="verDoc('MI6.03.02.06')">MI6.03.02.06</span>
                            </td>
                            <td width="25%" align="center">
                                <span style="font-family: Verdana; font-size: 10px; cursor: pointer; color: blue;"
                                    @click="verPdf('MI6.03.02.06')">MI6.03.02.06</span>
                            </td>
                            <td>
                                <font face="Verdana" size="1">Escaleras</font>
                            </td>
                        </tr>

                        <tr>
                            <td width="25%" align="center">
                                <span style="font-family: Verdana; font-size: 10px; cursor: pointer; color: blue;"
                                    @click="verDoc('MI6.03.02.07')">MI6.03.02.07</span>
                            </td>
                            <td width="25%" align="center">
                                <span style="font-family: Verdana; font-size: 10px; cursor: pointer; color: blue;"
                                    @click="verPdf('MI6.03.02.07')">MI6.03.02.07</span>
                            </td>
                            <td>
                                <font face="Verdana" size="1">Uso de elementos facilitadores para transporte de
                                    materiales</font>
                            </td>
                        </tr>

                        <tr>
                            <td width="25%" align="center">
                                <span style="font-family: Verdana; font-size: 10px; cursor: pointer; color: blue;"
                                    @click="verDoc('MI6.03.02.07')">MI6.03.02.07</span>
                            </td>
                            <td width="25%" align="center">
                                <span style="font-family: Verdana; font-size: 10px; cursor: pointer; color: blue;"
                                    @click="verPdf('MI6.03.02.07')">MI6.03.02.07</span>
                            </td>
                            <td>
                                <font face="Verdana" size="1">Condiciones a reunir por máquinas, herramientas y equipos
                                </font>
                            </td>
                        </tr>

                        <tr>
                            <td width="25%" align="center">
                                <span style="font-family: Verdana; font-size: 10px; cursor: pointer; color: blue;"
                                    @click="verDoc('MP6.03.03.01')">MP6.03.03.01</span>
                            </td>
                            <td width="25%" align="center">
                                <span style="font-family: Verdana; font-size: 10px; cursor: pointer; color: blue;"
                                    @click="verPdf('MP6.03.03.01')">MP6.03.03.01</span>
                            </td>
                            <td>
                                <font face="Verdana" size="1">Condiciones para el diseño de protección contra incendios
                                </font>
                            </td>
                        </tr>
                        <tr>
                            <td width="25%" align="center">
                                <span style="font-family: Verdana; font-size: 10px; cursor: pointer; color: blue;"
                                    @click="verDoc('MI6.03.04.01')">MI6.03.04.01</span>
                            </td>
                            <td width="25%" align="center">
                                <span style="font-family: Verdana; font-size: 10px; cursor: pointer; color: blue;"
                                    @click="verPdf('MI6.03.04.01')">MI6.03.04.01</span>
                            </td>
                            <td>
                                <font face="Verdana" size="1">Uso de protecciones auditivas
                                </font>
                            </td>
                        </tr>
                        <tr>
                            <td width="25%" align="center">
                                <span style="font-family: Verdana; font-size: 10px; cursor: pointer; color: blue;"
                                    @click="verDoc('MI6.03.04.02')">MI6.03.04.02</span>
                            </td>
                            <td width="25%" align="center">
                                <span style="font-family: Verdana; font-size: 10px; cursor: pointer; color: blue;"
                                    @click="verPdf('MI6.03.04.02')">MI6.03.04.02</span>
                            </td>
                            <td>
                                <font face="Verdana" size="1">Uso de protección ocular y facial</font>
                            </td>
                        </tr>
                        <tr>
                            <td width="25%" align="center">
                                <span style="font-family: Verdana; font-size: 10px; cursor: pointer; color: blue;"
                                    @click="verDoc('MI6.03.04.03')">MI6.03.04.03</span>
                            </td>
                            <td width="25%" align="center">
                                <span style="font-family: Verdana; font-size: 10px; cursor: pointer; color: blue;"
                                    @click="verPdf('MI6.03.04.03')">MI6.03.04.03</span>
                            </td>
                            <td>
                                <font face="Verdana" size="1">Tipos de protecciones personales</font>
                            </td>
                        </tr>
                        <tr>
                            <td width="25%" align="center">
                                <span style="font-family: Verdana; font-size: 10px; cursor: pointer; color: blue;"
                                    @click="verDoc('MI7.05.07.01')">MI7.05.07.01</span>
                            </td>
                            <td width="25%" align="center">
                                <span style="font-family: Verdana; font-size: 10px; cursor: pointer; color: blue;"
                                    @click="verPdf('MI7.05.07.01')">MI7.05.07.01</span>
                            </td>
                            <td>
                                <font face="Verdana" size="1">Seguridad en la gestión de residuos peligrosos y
                                    contaminantes</font>
                            </td>
                        </tr>
                        <tr>
                            <td width="25%" align="center">
                                <span style="font-family: Verdana; font-size: 10px; cursor: pointer; color: blue;"
                                    @click="verDoc('MI7.05.07.02')">MI7.05.07.02</span>
                            </td>
                            <td width="25%" align="center">
                                <span style="font-family: Verdana; font-size: 10px; cursor: pointer; color: blue;"
                                    @click="verPdf('MI7.05.07.02')">MI7.05.07.02</span>
                            </td>
                            <td>
                                <font face="Verdana" size="1">Uso, manipuleo y disposición segura de difenilos
                                    policlorados y sus desechos</font>
                            </td>
                        </tr>
                    </table>
                    <p style="margin-top: 0; margin-bottom: 0">&nbsp;</p>
                    <b>
                        <font color="#008000" face="Verdana">OBRAS</font>
                    </b>

                    <table border="1" width="100%">
                        <tr>
                            <td width="25%">
                                <p align="center"><b>
                                        <font face="Verdana" size="1">ARCHIVO EN .DOC</font>
                                    </b></p>
                            </td>
                            <td width="25%">
                                <p align="center"><b>
                                        <font face="Verdana" size="1">ARCHIVO EN .PDF</font>
                                    </b></p>
                            </td>
                            <td>
                                <p align="center"><b>
                                        <font face="Verdana" size="1">DESCRIPCIÓN</font>
                                    </b></p>
                            </td>
                        </tr>
                        <tr>
                            <td width="25%" align="center">
                                <span style="font-family: Verdana; font-size: 10px; cursor: pointer; color: blue;"
                                    @click="verDoc('CalidadObra')">EI 085 - Obras - Calidad</span>
                            </td>
                            <td width="25%" align="center">
                                <span style="font-family: Verdana; font-size: 10px; cursor: pointer; color: blue;"
                                    @click="verPdf('CalidadObra')">EI 085 - Obras - Calidad</span>
                            </td>
                            <td>
                                <font face="Verdana" size="1">Listado de chequeo resumen de Gestión de Calidad en Obras
                                </font>
                            </td>
                        </tr>
                        <tr>
                            <td width="25%" align="center">
                                <span style="font-family: Verdana; font-size: 10px; cursor: pointer; color: blue;"
                                    @click="verDoc('SSTyMAObra')">
                                    EI 085 - Obras - SST y MA
                                </span>
                            </td>
                            <td width="25%" align="center">
                                <span style="font-family: Verdana; font-size: 10px; cursor: pointer; color: blue;"
                                    @click="verPdf('SSTyMAObra')">
                                    EI 085 - Obras - SST y MA
                                </span>
                            </td>
                            <td>
                                <font face="Verdana" size="1">Listado de chequeo resumen de Gestión de SST y MA en Obras
                                </font>
                            </td>
                        </tr>
                    </table>
                    <p style="margin-top: 0; margin-bottom: 0">&nbsp;</p>
                    <b>
                        <font color="#008000" face="Verdana">SUCURSAL BS AS</font>
                    </b>

                    <table border="1" width="100%">
                        <tr>
                            <td width="25%">
                                <p align="center"><b>
                                        <font face="Verdana" size="1">ARCHIVO EN .DOC</font>
                                    </b></p>
                            </td>
                            <td width="25%">
                                <p align="center"><b>
                                        <font face="Verdana" size="1">ARCHIVO EN .PDF</font>
                                    </b></p>
                            </td>
                            <td>
                                <p align="center"><b>
                                        <font face="Verdana" size="1">DESCRIPCIÓN</font>
                                    </b></p>
                            </td>
                        </tr>
                        <tr>
                            <td width="25%" align="center">
                                <span style="font-family: Verdana; font-size: 10px; cursor: pointer; color: blue;"
                                    @click="verDoc('CalidadSucursalBsAs')">EI 085 - Sucursal Bs As - Calidad</span>
                            </td>
                            <td width="25%" align="center">
                                <span style="font-family: Verdana; font-size: 10px; cursor: pointer; color: blue;"
                                    @click="verPdf('CalidadSucursalBsAs')">EI 085 - Sucursal Bs As - Calidad</span>
                            </td>
                            <td>
                                <font face="Verdana" size="1">Listado de chequeo resumen de Gestión de Calidad en
                                    Sucursal Bs As</font>
                            </td>
                        </tr>
                        <tr>
                            <td width="25%" align="center">
                                <span style="font-family: Verdana; font-size: 10px; cursor: pointer; color: blue;"
                                    @click="verDoc('SSTyMASucursalBsAs')">
                                    EI 085 - Sucursal Bs As - SST y MA
                                </span>
                            </td>
                            <td width="25%" align="center">
                                <span style="font-family: Verdana; font-size: 10px; cursor: pointer; color: blue;"
                                    @click="verPdf('SSTyMASucursalBsAs')">
                                    EI 085 - Sucursal Bs As - SST y MA
                                </span>
                            </td>
                            <td>
                                <font face="Verdana" size="1">Listado de chequeo resumen de Gestión de SST y MA en
                                    Sucursal Bs As</font>
                            </td>
                        </tr>
                    </table>
                </v-card-text>
            </v-card>
            <VerDoc :visible="showDoc" :doc="this.doc" @close="showDoc = false">
            </VerDoc>
            <VerPdf :visible="showPdf" :codigo="this.doc" @close="showPdf = false">
            </VerPdf>
        </v-app>
    </div>
</template>

<script>
import VerDoc from "../Auditoria/Visualizardoc.vue";
import VerPdf from "../Auditoria/Visualizarpdf.vue";
export default {
    components: { VerDoc, VerPdf },
    data: (vm) => ({
        doc: "",
        showDoc: false,
        showPdf: false,
    }),
    computed: {
        show: {
            get() {

                return this.visible;
            },
            set(value) {
                if (!value) {
                    this.$emit("close");
                }
            },
        },
    },

    methods: {

        verDoc(item) {
            this.doc = item;
            this.showDoc = true;
        },
        verPdf(item) {
            this.doc = item;
            this.showPdf = true;
        },
    },
};
</script>